import { render, staticRenderFns } from "./paymentRequest.vue?vue&type=template&id=640ba7dc&"
import script from "./paymentRequest.vue?vue&type=script&lang=js&"
export * from "./paymentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports